export default {
  methods: {
    // 修改培训班信息
    editClass(id) {
      if (this.classInfo.class_level === 'B' || this.classInfo.class_level === 'A' || this.classInfo.class_level === 'PRO' || this.classInfo.class_train_type === 'continue_education' || this.classInfo.class_train_type === 'goalkeeper_education' || this.classInfo.class_train_type === 'physical_train' || this.classInfo.class_train_type === 'teacher_train' || this.classInfo.class_train_type === 'goalkeeper_train') {
        this.$router.push({
          path: 'create_high_class',
          query: {
            Cid: id,
            classTrainType: this.classInfo.class_train_type
          }
        })
      } else {
        if (this.isFive) {
          if(['early','L1'].includes(this.classInfo.class_level)){
            this.$router.push({
              name: "SystemEditTrainClassFive",
              params: { classId: id }
            });
          }else{
            this.$router.push({
              name: "SystemEditTrainClassFiveHigh",
              params: { classId: id }
            });
          }
          
        } else {
          this.$router.push({
            name: "SystemEditTrainClass",
            params: { classId: id }
          });
        }

      }
    },
    editClassByList(id) {
      // this.$router.push({
      //   name: "SystemEditTrainClass",
      //   params: { classId: id }
      // });
      if (this.isFive) {
        this.$router.push({
          name: "SystemEditTrainClassFive",
          params: { classId: id }
        });
      } else {
        this.$router.push({
          name: "SystemEditTrainClass",
          params: { classId: id }
        });
      }
    },
  }
};
